import { debounce } from 'lodash';
import domReady from '../helpers/dom-ready';

class Breadcrumbs {
  static init() {
    return new Breadcrumbs();
  }

  constructor() {
    this.breadcrumbs = document.querySelector('.breadcrumbs');

    if (this.breadcrumbs) {
      window.addEventListener('scroll', debounce(() => {
        this.toggleScroll();
      }), 300);
    }
  }

  toggleScroll() {
    if (document.body.classList.contains('-menu-type-transparent')) {
      if (window.scrollY > 50) {
        this.breadcrumbs.classList.add('-scroll');
      } else {
        this.breadcrumbs.classList.remove('-scroll');
      }
    }
  }
}

domReady(() => {
  Breadcrumbs.init();
});
